const headerComponent = document.getElementsByClassName('header')[0];
const headerContainer = document.getElementsByClassName('header-container')[0];

// Header scroll
if (headerComponent) {
  const scrollContainer = () => document.documentElement || document.body;



  // menu handlers

  // check mobile menu show/hide condition
  const mobileMenuStartPoint = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      '--mobile-menu-start-point'
    )
  );
  let isMobileMenuEnable =
    window.outerWidth <= mobileMenuStartPoint ||
    document.querySelector('.header-mobile');

  const desktopDropdownBreakpoint = 1200;
  const headerDropdownActiveClass = 'is-dropdown-active';
  const dropdownVisibleClass = 'is-visible';
  const dropdownItems = document.querySelectorAll('.menu-item.dropdown');
  const dropdownLinks = document.querySelectorAll('.menu-item.dropdown > .menu-link');
  const isDesktopDropdownMode = () => window.innerWidth > desktopDropdownBreakpoint;
  let desktopDropdownCloseTimeout = null;

  const syncDesktopDropdownWidth = () => {
    dropdownItems.forEach((item) => {
      const dropdownMenu = item.querySelector('.dropdown-menu');

      if (!dropdownMenu) {
        return;
      }

      if (!isDesktopDropdownMode()) {
        dropdownMenu.style.removeProperty('--dropdown-menu-width');
        return;
      }

      const dropdownLinksEls = Array.from(
        dropdownMenu.querySelectorAll('.menu-link')
      );

      let maxLinkWidth = 0;

      dropdownLinksEls.forEach((link) => {
        maxLinkWidth = Math.max(maxLinkWidth, Math.ceil(link.scrollWidth));
      });

      const contentWidth = maxLinkWidth ? maxLinkWidth + 56 : 200;
      dropdownMenu.style.setProperty(
        '--dropdown-menu-width',
        `${Math.max(contentWidth, 200)}px`
      );
    });
  };

  const cancelDesktopDropdownClose = () => {
    if (desktopDropdownCloseTimeout) {
      clearTimeout(desktopDropdownCloseTimeout);
      desktopDropdownCloseTimeout = null;
    }
  };

  const showDesktopDropdown = (item) => {
    const dropdownMenu = item?.querySelector('.dropdown-menu');

    if (!dropdownMenu) {
      return;
    }

    dropdownMenu.style.display = 'block';

    window.requestAnimationFrame(() => {
      dropdownMenu.classList.add(dropdownVisibleClass);
    });
  };

  const hideDesktopDropdown = (item) => {
    const dropdownMenu = item?.querySelector('.dropdown-menu');

    if (!dropdownMenu) {
      return;
    }

    dropdownMenu.classList.remove(dropdownVisibleClass);

    window.setTimeout(() => {
      if (!item.classList.contains('active')) {
        dropdownMenu.style.display = '';
      }
    }, 240);
  };

  const setActiveDesktopDropdown = (currentDropdown) => {
    dropdownItems.forEach((item) => {
      const isCurrent = item === currentDropdown;

      item.classList.toggle('active', isCurrent);

      if (isCurrent) {
        showDesktopDropdown(item);
      } else {
        hideDesktopDropdown(item);
      }
    });

    if (currentDropdown) {
      headerComponent.classList.add(headerDropdownActiveClass);
    } else {
      headerComponent.classList.remove(headerDropdownActiveClass);
    }
  };

  const clearDesktopDropdownState = () => {
    cancelDesktopDropdownClose();
    dropdownItems.forEach((item) => {
      item.classList.remove('active');
      hideDesktopDropdown(item);
    });
    headerComponent.classList.remove(headerDropdownActiveClass);
  };

  const scheduleDesktopDropdownClose = () => {
    if (!isDesktopDropdownMode()) {
      return;
    }

    cancelDesktopDropdownClose();
    desktopDropdownCloseTimeout = window.setTimeout(() => {
      clearDesktopDropdownState();
    }, 120);
  };

  dropdownLinks.forEach((link) => {
    link.addEventListener('mouseenter', () => {
      if (!isDesktopDropdownMode()) {
        return;
      }

      const currentDropdown = link.closest('.menu-item.dropdown');
      cancelDesktopDropdownClose();
      setActiveDesktopDropdown(currentDropdown);
    });
  });

  dropdownItems.forEach((item) => {
    item.addEventListener('mouseenter', () => {
      if (!isDesktopDropdownMode()) {
        return;
      }

      cancelDesktopDropdownClose();
      setActiveDesktopDropdown(item);
    });

    item.addEventListener('mouseleave', () => {
      if (!isDesktopDropdownMode()) {
        return;
      }

      scheduleDesktopDropdownClose();
    });
  });

  const dropdownToggle = document.querySelectorAll('.dropdown-toggle');

  dropdownToggle.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      if (isMobileMenuEnable) {
        const menuItem = this.closest('.menu-item.dropdown');
        const dropdownMenu = this.nextElementSibling;
        if (!menuItem || !dropdownMenu) {
          return;
        }
        e.preventDefault();
        const isAlreadyActive = menuItem.classList.contains('active');

        const activeDropdowns = document.querySelectorAll(
          '.menu-item.dropdown.active'
        );
        activeDropdowns.forEach((item) => {
          const menu = item.querySelector('.dropdown-menu');
          if (menu) {
            menu.style.maxHeight = '0px';
            menu.style.opacity = '0';
          }
          item.classList.remove('active');
        });

        if (isAlreadyActive) {
          return;
        }

        menuItem.classList.add('active');
        dropdownMenu.style.maxHeight = dropdownMenu.scrollHeight + 'px';
        dropdownMenu.style.opacity = '1';
      }
    });
  });

  // toggle menu handler
  function menuToggleFunc() {
    const burgerBtn = document.querySelector('.burger-btn');
    const menuToggle = document.querySelector('.menu-toggle');
    const navbarNav = document.querySelector('.navbar-nav');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');

    headerComponent.classList.toggle('is-open-menu');
    if (burgerBtn) burgerBtn.classList.toggle('active');
    if (menuToggle) menuToggle.classList.toggle('active');
    if (navbarNav) navbarNav.classList.toggle('active');
    if (headerCloseWrapper) headerCloseWrapper.classList.toggle('active');

    // LockScroll when burger open and enable when closed and enable scroll on menu
    if (scrollLock.getScrollState()) {
      scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
      scrollLock.addScrollableSelector('.simplebar-content-wrapper');
      window.lenis?.stop();
    } else {
      scrollLock.enablePageScroll();
      window.lenis?.start();
    }
  }

  // menu update function
  function updateMenu() {
    isMobileMenuEnable =
      window.outerWidth <= mobileMenuStartPoint ||
      document.querySelector('.mobile-header');

    if (!isDesktopDropdownMode()) {
      clearDesktopDropdownState();
    }

    syncDesktopDropdownWidth();

    if (!isMobileMenuEnable) {
      const dropdownMenus = document.querySelectorAll('.dropdown-menu');
      dropdownMenus.forEach((menu) => {
        menu.style.display = '';
        menu.style.maxHeight = '';
        menu.style.opacity = '';
        menu.classList.remove(dropdownVisibleClass);
      });

      const headerCloseWrapper = document.querySelector(
        '.header-close-wrapper'
      );
      headerCloseWrapper.classList.remove('active');

      const activeMenuItems = document.querySelectorAll('.menu-item.active');
      activeMenuItems.forEach((item) => {
        item.classList.remove('active');
      });

      const navbarNav = document.querySelector('.navbar-nav');
      navbarNav.classList.remove('active');

      const menuToggle = document.querySelector('.menu-toggle');
      if (menuToggle) menuToggle.classList.remove('active');

      const burgerBtn = document.querySelector('.burger-btn');
      if (burgerBtn) burgerBtn.classList.remove('active');

      headerComponent.classList.remove('is-open-menu');

      // LockScroll when burger open and enable when closed
      scrollLock.enablePageScroll();
      window.lenis?.start();
    }
  }

  window.addEventListener('resize', updateMenu);
  window.addEventListener('orientationchange', updateMenu);
  window.addEventListener('load', syncDesktopDropdownWidth);

  // end of toggle menu handler

  const burgerBtn = document.querySelector('.burger-btn');
  const headerCloseWrapper = document.querySelector('.header-close-wrapper');

  if (burgerBtn) burgerBtn.addEventListener('click', menuToggleFunc);
  if (headerCloseWrapper) headerCloseWrapper.addEventListener('click', menuToggleFunc);

  // Hide and show Header when scroll up
  function headerSticky() {
    let prevScrollPos = window.scrollY;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const headerHeight = headerComponent.scrollHeight;

      if (currentScrollPos > 100) {
        if (prevScrollPos > currentScrollPos) {
          headerComponent.style.top = window.innerWidth > 768 ? '0' : '0';
          headerComponent.classList.add('scrolled');
        } else {
          headerComponent.style.top = `-${headerHeight + 3}px`;
        }
      } else {
        headerComponent.style.top = '0';
        if (currentScrollPos === 0) {
          headerComponent.classList.remove('scrolled');
        } else {
          headerComponent.classList.add('scrolled');
        }
      }

      prevScrollPos = currentScrollPos;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  headerSticky();
  syncDesktopDropdownWidth();
}
